import React from 'react'
import { cn } from './cn'

export interface SkeletonProps {
  width: number | string
  height?: number
  className?: string
}

/** Decorative loading line; shared keyframes live with the theme. */
export function Skeleton({ width, height = 12, className }: SkeletonProps) {
  return <span className={cn('kv-sk', className)} style={{ width, height }} aria-hidden="true" />
}
